import * as requestFromServer from "./serviceProviderSubscriptionsApis";
import Actions from "../../actions";

// service provider subscriptions -> get service provider subscriptions api
export const getServiceProviderSubscriptionsAction =
  (setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderSubscriptions();
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_SERVICE_PROVIDER_SUBSCRIPTIONS_LIST, {
          serviceProviderSubscriptions: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider subscriptions -> get service provider subscriptions api
export const getAdminSubscriptionsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getSuperAdminSubscriptions();
  if (response) {
    dispatch(
      Actions.createAction(Actions.GET_SERVICE_PROVIDER_SUBSCRIPTIONS_LIST, {
        serviceProviderSubscriptions: response,
      })
    );
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// service provider subscriptions -> get service provider subscriptions api
export const getServiceProviderSubscriptionPlanHistoryAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getServiceProviderSubscriptionPlanHistory(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_SUBSCRIPTION_PLAN_HISTORY_LIST, {serviceProviderSubscriptionPlanHistory:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

// service provider organization sponsorship -> get service provider organization sponsorship api
export const getServiceProviderOrganizationSponsorshipHistoryAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getServiceProviderOrganizationSponsorshipHistory(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_ORGANIZATION_SPONSORSHIP_HISTORY_LIST, {serviceProviderOrganizationSponsorshipHistory:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

// service provider push notification history -> get service provider push notification history api
export const getServiceProviderPushNotificationHistoryAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getServiceProviderPushNotificationHistory(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_PUSH_NOTIFICATION_HISTORY_LIST, {serviceProviderPushNotificationHistory:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

export const updateSubscriptionPlanByIdAction =
  (id, dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateSubscriptionPlan(
      id,
      dataToBeSent
    );
    if (response) {
      getServiceProviderSubscriptionsAction(setLoading);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const updateSubscriptionPlanAutoCreditByIdAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateSubscriptionPlanAutoCredit(
      dataToBeSent
    );
    if (response) {
      getServiceProviderSubscriptionsAction(setLoading);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
